$(function() {
    $('#neighborhood-navigator-modal').hide();
    $('#article-survey-feedback-form').submit(function(e) {
        var form, missing;
        form = $(this);
        missing = [];
        form.find('input.required:radio').each(function(index, element) {
            var checkboxes;
            checkboxes = form.find('input.required:radio');
            if (!checkboxes.is(':checked')) {
                 return missing.push($(element));
            }
        });
        form.find('input.required:checkbox').each(function(index, element) {
            var checkboxes;
            checkboxes = form.find('input.required:checkbox');
            if (!checkboxes.is(':checked')) {
                return missing.push($(element));
            }
        });
        form.find("select.required").each(function(index, element) {
            if ($(element).val() === '') {
                return missing.push($(element));
            }
        });
        form.find("input.required:text").each(function(index, element) {
            if ($(element).val() === '') {
                return missing.push($(element));
            }
        });
        form.find("textarea.required").each(function(index, element) {
            if ($(element).val() === '') {
                return missing.push($(element));
            }
        });
        if (missing.length < 1) {
            form.find('input[type=submit]').attr('disabled', 'disabled');
            form.find('input:checkbox').filter(function() {
                return !this.value;
            }).attr('disabled', 'disabled');
            return true;
        } else {
            e.preventDefault();
            alert('You are missing some required fields (noted in parentheses). Complete all data and resubmit.');
            return false;
        }
    });
    $('.pre-flight-check').blur(function(e) {
        $.ajax({
            url: '/email_processors',
            type: 'POST',
            data: { email: $(this).val(), client_id: $('.client-identifier').val() },
            dataType: 'SCRIPT'
        });
    });
    if ($('#saved-articles-list')[0]) {
        return $('#saved-articles-list [data-method="delete"]').on('ajax:success', function(ev) {
            return $(ev.currentTarget).closest('li').slideUp(250, function() {
                return $(this).text('Article removed from your saved list');
            }).delay(250).slideDown(250).delay(1500).slideUp();
        });
    }
});
